import { Block } from "bem-cn";
import { matchSorter } from "match-sorter";
import { Link } from "react-router-dom";
import { Cell, HeaderGroup, Row } from "react-table";
import { TBusyValue } from "../BusyComboBox/BusyComboBox.utils";
import ColorLabel from "../ColorLabel/ColorLabel";
import IndeterminateCheckbox from "../IndeterminateCheckbox/IndeterminateCheckbox";
import TagList from "../TagList/TagList";

// Define a default UI for filtering
export function DefaultColumnFilter({
  column: { filterValue, preFilteredRows, setFilter },
}: any) {
  const count = preFilteredRows.length;

  return (
    <input
      hidden
      value={filterValue || ""}
      onChange={(e) => {
        setFilter(e.target.value || undefined); // Set undefined to remove the filter entirely
      }}
      placeholder={`Search ${count} records...`}
    />
  );
}

export function fuzzyTextFilterFn(rows: any, id: any, filterValue: any) {
  return matchSorter(rows, filterValue, {
    keys: [(row: any) => row.values[id]],
  });
}

// Let the table remove the filter if the string is empty
fuzzyTextFilterFn.autoRemove = (val: any) => !val;

export const filterByText = (rows: any, id: any, filterValue: any) => {
  return rows.filter((row: any) => {
    const rowValue = row.values[id];
    return rowValue !== undefined
      ? String(rowValue)
          .toLowerCase()
          .startsWith(String(filterValue).toLowerCase())
      : true;
  });
}

export function filterByTags(rows: any, id: any, filterValue: string | tagList) {
  if (filterValue.length === 0) return rows;
  const fv =
    typeof filterValue == "string"
      ? (JSON.parse(filterValue) as tagList)
      : (filterValue as tagList);

  return rows.filter((row: any) => {
    const tags: string[] = row.values[id]
      .split(",")
      .filter((item: string) => item.trim().length > 0);

    return fv.every((val) =>
      tags.some((tag) => val.value.toLowerCase() === tag.trim().toLowerCase())
    );
  });
}

filterByTags.autoRemove = (val: string) => !val;

export function filterByBusy(rows: any, id: any, filterValue: TBusyValue[]) {
  if (filterValue.length === 0) return rows;

  // const fv: string[] = filterValue as any;
  // if (fv.length === 0) return rows;
  // return rows.filter((row: any) => filterValue.includes(row.values[id]));

  return rows.filter((row: any) => {
    const cellValue: string | number = row.values[id];
    if (typeof cellValue === "string") {
      return filterValue.includes(cellValue);
    } else {
      return filterValue.some((val) => {
        if (typeof val === "string" || typeof val === "number") {
          return val === cellValue;
        } else {
          const minValue = val[0];
          const maxValue = val[1];
          return cellValue >= minValue && cellValue <= maxValue;
        }
      });
    }
  });
}

filterByBusy.autoRemove = (val: string) => !val;

const onClickRowCheckbox = () => {};

export const setCellContent = (
  index: number,
  row: Row<object>,
  cell: Cell<object, any>,
  headerGroups: HeaderGroup<object>[],
  isAuth: boolean,
  b: Block
): any => {
  const [hg] = headerGroups;
  const { headers } = hg;
  const { id } = headers[index];

  if (id === "name")
    return (
      <IndeterminateCheckbox
        text={cell.render("Cell")}
        onChangeEx={onClickRowCheckbox}
        {...row.getToggleRowSelectedProps()}
      />
    );
  if (id === "stack")
    return (
      <div className={b("body-cell-wrapper-stack")}>
        <TagList text={cell.value} />
      </div>
    );

  if (id === "busy")
    return (
      <div className={b("ColorLabel-wrapper")}>
        <ColorLabel text={cell.value} />
      </div>
    );

  if (id === "booking") {
    return <Link to={isAuth ? "/booking" : "/sign-in"}>{cell.value}</Link>;
  }

  if (id === "rate")
    return isAuth ? (
      cell.render("Cell")
    ) : (
      <Link to="/sign-up">Доступна после регистрации</Link>
    );

  return cell.render("Cell");
};